(function () {
    var $form = $('.franchise-application form');

    if ($form.length === 0) return;

    // Form validation
    var options = {
        groupClass: 'has-error',
        groupSelector: '.form-group',
        errorPosClasses: ['.input-group', '.selectize-control'],
        helpSpanDisplay: 'help-block',
        delay: false,
        disableSubmitBtn: false,
    };

    var metrics = [
        ['select[name="title"]', 'presence', gmtrans('franchise.apply.frontend_validation.title_required')],
        ['input[name="first_name"]', 'presence', gmtrans('franchise.apply.frontend_validation.firstname_required')],
        ['input[name="last_name"]', 'presence', gmtrans('franchise.apply.frontend_validation.lastname_required')],
        ['input[name="email"]', 'presence', gmtrans('franchise.apply.frontend_validation.email_required')],
        ['input[name="phone"]', 'presence', gmtrans('franchise.apply.frontend_validation.phone_required')],
        ['input[name="address1"]', 'presence', gmtrans('franchise.apply.frontend_validation.address_required')],
        ['input[name="city"]', 'presence', gmtrans('franchise.apply.frontend_validation.city_required')],
        ['input[name="county"]', 'presence', gmtrans('franchise.apply.frontend_validation.county_required')],
        ['input[name="postcode"]', 'presence', gmtrans('franchise.apply.frontend_validation.postcode_required')],
        ['select[name="country"]', 'presence', gmtrans('franchise.apply.frontend_validation.country_required')],

        [
            'input[name="company_name"]',
            'presence',
            gmtrans('franchise.apply.frontend_validation.company_name_required'),
        ],
        ['input[name="fleet_size"]', 'presence', gmtrans('franchise.apply.frontend_validation.fleet_size_required')],
        [
            'input[name="number_of_locations"]',
            'presence',
            gmtrans('franchise.apply.frontend_validation.number_of_locations_required'),
        ],
        [
            'select[name="country_of_interest"]',
            'presence',
            gmtrans('franchise.apply.frontend_validation.country_of_interest_required'),
        ],
        [
            'input[name="state_or_city_of_interest"]',
            'presence',
            gmtrans('franchise.apply.frontend_validation.state_or_city_of_interest_required'),
        ],
        [
            'input[name="available_capital"]',
            'presence',
            gmtrans('franchise.apply.frontend_validation.available_capital_required'),
        ],
        ['input[name="timeframe"]', 'presence', gmtrans('franchise.apply.frontend_validation.timeframe_required')],
        ['textarea[name="comments"]', 'presence', gmtrans('franchise.apply.frontend_validation.comments_required')],
    ];

    $form.nod(metrics, options);
})();
